module.exports = __webpack_public_path__ + "list-bg.jpg?221bdfefb3e138beaff67f784177c97d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list-bg.jpg
// module id = 10
// module chunks = 0